import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from './AuthContext';
import NavBar from './components/NavBar';
import Home from './components/Home';
import Login from './components/Login';
import Register from './components/Register';
import HerdManagement from './components/HerdManagement';
import CowDetail from './components/CowDetail';
import CowForm from './components/CowForm';
import Receipts from './components/Receipts';
import Balances from './components/Balances';
import MyInfo from './components/MyInfo';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const AppRouter = () => (
  <Router>
    <NavBar />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/herd" element={<ProtectedRoute><HerdManagement /></ProtectedRoute>} />
      <Route path="/herd/new" element={<ProtectedRoute><CowForm /></ProtectedRoute>} />
      <Route path="/herd/:id" element={<ProtectedRoute><CowDetail /></ProtectedRoute>} />
      <Route path="/herd/:id/edit" element={<ProtectedRoute><CowForm /></ProtectedRoute>} />
      <Route path="/receipts" element={<ProtectedRoute><Receipts /></ProtectedRoute>} />
      <Route path="/balances" element={<ProtectedRoute><Balances /></ProtectedRoute>} />
      <Route path="/my-info" element={<ProtectedRoute><MyInfo /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>
);

export default AppRouter;
